import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { HeritageSeal } from "@/components/primitives";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-checking">
        <HeritageSeal size={90} />
        <p className="font-display italic text-ink-soft">Opening the patch...</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/auth" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
